<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  item: { type: Object, required: true },
});

const emit = defineEmits(['open']);
const { t } = useI18n();

const responsibleName = computed(
  () => props.item.responsible?.name || t('POST_SALE.COMMON.UNASSIGNED')
);

const responsibleShortName = computed(() => {
  const [firstName, secondName] = responsibleName.value.split(' ');
  if (!firstName) return '';
  return `${firstName}${secondName ? ` ${secondName[0]}.` : ''}`.toUpperCase();
});

const initials = computed(() =>
  responsibleName.value
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(name => name[0].toUpperCase())
    .join('')
);

const address = computed(() => {
  const value = props.item.transaction?.address || {};
  const street = [value.logradouro || value.endereco, value.numero]
    .filter(Boolean)
    .join(', ');
  const unit = value.unidade ? ` / ${value.unidade}` : '';

  return {
    main: `${street}${unit}`,
    complement: [value.complemento, value.bairro].filter(Boolean).join(', '),
  };
});
</script>

<template>
  <td class="p-3 align-top">
    <div class="flex items-center gap-2">
      <span
        class="grid size-7 shrink-0 place-items-center rounded-full bg-lais-primary-50 text-xs font-bold text-lais-primary"
        aria-hidden="true"
      >
        {{ initials }}
      </span>
      <span
        class="rounded-full bg-lais-bg-soft px-2 py-1 text-xs font-semibold text-lais-text-body"
      >
        {{ responsibleShortName }}
      </span>
    </div>
  </td>
  <td class="p-3 align-top">
    <button
      type="button"
      class="text-left hover:text-lais-primary"
      @click="emit('open', item)"
    >
      <p class="font-semibold text-lais-text">
        {{ address.main || t('POST_SALE.COMMON.ADDRESS_UNAVAILABLE') }}
      </p>
      <span v-if="address.complement" class="text-xs text-lais-text-muted">
        {{ address.complement }}
      </span>
    </button>
  </td>
</template>
